import { MouseEventHandler, useState } from 'react';
import styled from 'styled-components';

import BrandAvatarFallback from './BrandAvatarFallback';

const Img = styled.img<{ $size: number }>`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: 50%;
  object-fit: cover;
  flex: none;
`;

type Props = {
  // Real uploaded avatar URL — empty when no upload. Pass the data field, never a default-returning endpoint.
  src?: string | null;
  name?: string;
  size?: number;
  onClick?: MouseEventHandler<HTMLElement>;
  className?: string;
};

export default function BrandAvatar({ src, name, size = 34, onClick, className }: Props) {
  const [failed, setFailed] = useState(false);

  // Render the real upload when present; a genuinely-dead URL fails onError → initials.
  if (src && !failed) {
    return <Img $size={size} src={src} alt={name ?? ''} onClick={onClick} className={className} onError={() => setFailed(true)} />;
  }
  return <BrandAvatarFallback name={name} size={size} onClick={onClick} className={className} />;
}
